//@ts-nocheck
import React from 'react';
import { MappingContext } from "./mappingContext";
export class MappingProvider extends React.PureComponent {
  render() {
    const {
      styles,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement(MappingContext.Provider, {
      value: styles
    }, children);
  }

}